<template>
  <div :class="[$style.logoContainer, ...customClasses]">
    <XLink
      :to="link"
      plain
      data-testid="navLogoLink"
      title="Clicksign logo"
    >
      <XLogo
        height="48px"
        color="black"
      />
    </XLink>
    <slot name="actions" />
  </div>
</template>

<script>
export default {
  name: 'AuthNavLogo',
  props: {
    customClasses: {
      type: Array,
      default: () => [],
    },
    link: {
      type: String,
      default: '/signin',
    },
  },
};
</script>

<style lang="scss" module>
.logoContainer {
  position: relative;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  padding: var(--space-large) 0px;
}
</style>
